import { CSSInterpolation, styled, Theme, useThemeProps } from '@mui/material'
import clsx from 'clsx'

export type CountBadgeColor =
  | 'neutral'
  | 'secondary'
  | 'success'
  | 'error'
  | 'warning'
  | 'info'
  | 'neutralStrong'
  | 'bronze'
  | 'gold'
  | 'orange'
  | 'lime'
  | 'mint'
  | 'pink'

export type CountBadgeProps = {
  count: number | string
  color?: CountBadgeColor
  className?: string
}

type OwnerState = { color: CountBadgeColor }

type SlotStyle = CSSInterpolation | ((arg: { theme: Theme; ownerState: OwnerState }) => CSSInterpolation)

export type OmuiCountBadgeComponent = {
  defaultProps?: Partial<CountBadgeProps>
  styleOverrides?: {
    root?: SlotStyle
  }
  variants?: Array<{
    props: Partial<OwnerState>
    style: SlotStyle
  }>
}

declare module '@mui/material/styles' {
  interface Components {
    OmuiCountBadge?: OmuiCountBadgeComponent
  }

  interface ComponentsPropsList {
    OmuiCountBadge: Partial<OwnerState>
  }
}

export const omuiCountBadgeClasses = {
  root: 'OmuiCountBadge-root',
} as const

const CountBadgeRoot = styled('span', {
  name: 'OmuiCountBadge',
  slot: 'Root',
  overridesResolver: (_props, styles) => styles.root,
})<{ ownerState: OwnerState }>({})

export const CountBadge = (inProps: CountBadgeProps) => {
  const props = useThemeProps({ props: inProps, name: 'OmuiCountBadge' })
  const { count, color = 'neutral', className } = props
  const ownerState: OwnerState = { color }

  return (
    <CountBadgeRoot ownerState={ownerState} className={clsx(omuiCountBadgeClasses.root, className)}>
      {count}
    </CountBadgeRoot>
  )
}
